/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyQuestion from './survey-question';
import SurveyQuestionDetail from './survey-question-detail';
import SurveyQuestionUpdate from './survey-question-update';
import SurveyQuestionDeleteDialog from './survey-question-delete-dialog';

const SurveyQuestionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyQuestion />} />
    <Route path="new" element={<SurveyQuestionUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyQuestionDetail />} />
      <Route path="edit" element={<SurveyQuestionUpdate />} />
      <Route path="delete" element={<SurveyQuestionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyQuestionRoutes;
